<template>
    <div class="block">
        <div class="table__responsive">
            <table class="table">
                <tbody>
                <tr v-for="market in pending" @click.prevent="selected(market)">
                    <td>
                        {{market.name}}
                    </td>
                    <td>
                        <i v-if="market.pending" class="mdi mdi-settings" v-tooltip.right="'Wachtend op je reactie...'"></i>
                    </td>
                    <td>
                        Accepteren
                    </td>
                    <td>
                        Afwijzen
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <div class="table__responsive">
            <table class="table">
                <tbody>
                <tr v-for="market in pending" @click.prevent="selected(market)">
                    <td>
                        {{market.name}}
                    </td>
                    <td>
                        <i class="mdi mdi-check" v-tooltip.left="'Geaccepteerd'"></i>
                    </td>
                    <td>
                        {{formatDate(market.accepted)}}
                    </td>
                    <td class="delete">
                        <!--<i class="mdi mdi-delete"></i>-->
                        Verwijderen
                    </td>
                </tr>
                <tr v-for="market in accepted" @click.prevent="selected(market)">
                    <td>
                        {{market.name}}
                    </td>
                    <td>
                        <i class="mdi mdi-check" v-tooltip.left="'Geaccepteerd'"></i>
                    </td>
                    <td>
                        {{formatDate(market.accepted)}}
                    </td>
                    <td class="delete">
                        <!--<i class="mdi mdi-delete"></i>-->
                        Verwijderen
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <div class="loading" v-if="loading">
            <div class="spinner" style="top: 40%;"></div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import firebase from 'firebase';
    import moment from 'moment';

    require("firebase/firestore");

    @Component
    export default class MarketsPage extends Vue {

        loading = true;

        empty = false;

        accepted = [];

        pending = [];

        mounted() {
//            console.log('Markets', new Date().getTime());
//            firebase.auth().onAuthStateChanged((user) => {
//                if (user) {
//                    console.log('Markets', 'Attached');
//
//                    this.fetch(user.uid);
//                }else{
//                    // No user is signed in.
//                    console.log('Markets', 'User is signed out');
//                    this.$router.push('/auth');
//                }
//            });
        }

        fetch(uid) {
//            this.loading = true;
//
//            firebase.firestore().collection('users').doc(uid).collection('markets')
//              .get()
//              .then((querySnapshot) => {
//                  querySnapshot.forEach((doc) => {
//                      console.log(doc.id, " => ", doc.data());
//
//                      var newPending = [];
//                      var newAccepted = [];
//                      if (doc.data().pending) {
//                          newPending.push(doc.data());
//                      } else {
//                          newAccepted.push(doc.data());
//                      }
//
//                      this.accepted = newAccepted;
//                      this.pending = newPending;
//
//                      this.loading = false;
//                  })
//              }, (error) => {
//                console.log("Error getting documents: ", error);
//            });
        }

        selected(market) {
            console.log('Markets', 'Selected market: ', market);
            this.$router.push({ name: 'market-dashboard', params: { key: market.key }});
        }

        formatDate(stamp) {
            return moment(stamp).format('DD MMMM YYYY');
        }
    }

    Vue.component('page-not-found', MarketsPage);
</script>

<style src="./markets.scss" lang="scss" scoped></style>




// WEBPACK FOOTER //
// src/pages/markets/MarketsPage.vue